<template>
  <div class="image-input">
    <input
      type="file"
      style="display: none"
      ref="fileInputElement"
      @change="pickFile"
      accept="image/png, image/jpeg"
    />

    <button type="button" :style="buttonStyle" @click="openFilePicker">
      <i v-if="!url" class="fas fa-user"></i>

      <div class="icon-wrapper">
        <i class="fas fa-camera"></i>
      </div>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: null
    }
  },
  computed: {
    buttonStyle() {
      const style = {};
      if (this.url) {
        style["background-image"] = `url(${this.url})`;
      }
      return style;
    }
  },
  methods: {
    openFilePicker() {
      this.$refs.fileInputElement.click();
    },
    pickFile() {
      const selectedFile = this.$refs.fileInputElement.files[0];
      if (selectedFile && selectedFile.size > 1000000) {
        this.$message.error("Imagem muito grande. Tamanho máximo: 1MB");
        return;
      }
      if (
        selectedFile &&
        ["image/png", "image/jpeg"].includes(selectedFile.type)
      ) {
        const reader = new FileReader();
        reader.addEventListener(
          "load",
          () => {
            this.$emit("pick", reader.result);
          },
          false
        );
        reader.readAsDataURL(selectedFile);
      } else {
        this.$message.error("Formato de arquivo inválido");
      }
      this.$refs.fileInputElement.value = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.image-input {
  button {
    max-width: 80px;
    min-width: 80px;
    max-height: 80px;
    min-height: 80px;
    border-radius: 80px;
    background-color: #818181;
    background-size: cover;
    background-position: center;
    border: none;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 40px;

    .icon-wrapper {
      position: absolute;
      background: #fb263e;
      bottom: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      height: 28px;
      width: 28px;
      border-radius: 28px;
      font-size: 16px;
    }
  }
}
</style>
